import { Axios } from './../shared/Axios';
import qs from 'qs';

class RewardService extends Axios {

    private static instance: RewardService;

    static get(): RewardService {
        if (!RewardService.instance) {
            RewardService.instance = new RewardService();
        }
        return RewardService.instance;
    }

    async getCategories(data: object): Promise<any> {
        return this.instance.get(`/admin/reward${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async updateCategory(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/reward/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async saveCategory(data: object): Promise<any> {
        return this.instance.post(`/admin/reward`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async deleteCategory(id: number): Promise<any> {
        return this.instance.delete(`/admin/reward/${id}`)
    }

    async getTopups(data: object): Promise<any> {
        return this.instance.get(`/admin/reward/topup${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async updateTopup(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/reward/topup/${id}`, data)
    }

    async saveTopup(data: object): Promise<any> {
        return this.instance.post(`/admin/reward/topup`, data)
    }

    async deleteTopup(id: number): Promise<any> {
        return this.instance.delete(`/admin/reward/topup/${id}`)
    }



}


const rewardService = RewardService.get();

export { rewardService as RewardService }